import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, provide } from "vue";
import HeaderMenu from "../components/referral/HeaderMenu.vue";
import ReferralCode from "../components/referral/ReferralCode.vue";
import ReferralHistory from "../components/referral/ReferralHistory.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferralIndex',
  setup(__props) {

const t = useI18n().t;
const isLoading = ref(false);
provide("isLoading", isLoading);
const tabs = ref([
  {
    name: t("fields.referralCode"),
    component: "ReferralCode",
    id: 1,
  },
  {
    name: t("fields.referralHistory"),
    component: "ReferralHistory",
    id: 2,
  },
]);
const componentMap = {
  ReferralCode,
  ReferralHistory,
};
const currentTab = ref(1);

const handleTabs = (id: number) => {
  currentTab.value = id;
};

const getComponent = (componentName: string) => {
  return componentMap[componentName];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderMenu, {
      tabs: tabs.value,
      onChangeTab: handleTabs
    }, null, 8, ["tabs"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.id
      }, [
        (currentTab.value === tab.id)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(tab.component)), { key: 0 }))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}
}

})